export const ACRONYMS = '';
